let trainingData = [
  {id: 1, title: "Training2", description: "This is a sample training"},
  {id: 2, title: "Training3", description: "This is a sample training"},
  {id: 3, title: "Training1", description: "This is a sample training"},
  {id: 4, title: "Training4", description: "This is a sample training"},
  {id: 5, title: "Training5", description: "This is a sample training"},
];
export default trainingData;